<template>
    <section v-if="sectionVisibility || glb.isSSR">
        <div class="grid xs-grid-cols-1">
            <div class="f4 text-bold">{{getGeoDisplayText}} {{molang('search.common.marketOverview')}}</div>
            <div>
                <span v-show="getMarketInfo && getMarketInfo.updateDate">Last updated .</span>
                <button class="link" type="button" @click="saveSearch">{{molang('search.common.saveSearchLink')}}</button> {{molang('search.common.saveSearchDesc')}} {{getGeoDisplayText}}
            </div>
            <ul class="market-overview">
                <li>
                    <a :href="getMapSearchLinks.base" class="count">
                        <p class="num total">{{$filters.formatNumber(getMapSearchLinks.baseCount)}}</p>
                        <p class="unit">{{molang('search.common.homesForSale')}}</p>
                    </a>
                </li>
                <li>
                    <a :href="getMapSearchLinks.filteredUrlObj.newCount ? getMapSearchLinks.filteredUrlObj.new : 'javascript:void(0);'" class="count">
                       <p class="num new">{{$filters.formatNumber(getMapSearchLinks.filteredUrlObj.newCount)}}</p>
                       <p class="unit">{{molang('search.common.newHomes')}}</p>
                   </a>
                </li>
                <li>
                    <a :href="getMapSearchLinks.filteredUrlObj.openHouseCount ? getMapSearchLinks.filteredUrlObj.openHouse : 'javascript:void(0);'" class="count">
                       <p class="num open">{{$filters.formatNumber(getMapSearchLinks.filteredUrlObj.openHouseCount)}}</p>
                       <p class="unit">{{molang('search.common.openHouses')}}</p>
                   </a>
                </li>
               <li>
                    <a :href="getMapSearchLinks.filteredUrlObj.priceReduceCount ? getMapSearchLinks.filteredUrlObj.priceReduce : 'javascript:void(0);'" class="count">
                       <p class="num open">{{$filters.formatNumber(getMapSearchLinks.filteredUrlObj.priceReduceCount)}}</p>
                       <p class="unit">{{molang('search.card.priceReduced')}}</p>
                   </a>
                </li>
            </ul>
            <mvtMarketTrendsCTA :geoInfo="geo"></mvtMarketTrendsCTA>
        </div>
    </section>
</template>

<script src="./market-overview.js"></script>

<style lang="scss">
@use "./market-overview.scss" as *;
</style>
